import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import _ from "lodash";
import moment from "moment";
import { verifyauthCheck, getExpertTipsList } from "../handlers/adminApi";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faTrash, faPenToSquare, faDownload, faChevronDown, faLocationDot, faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';
import road from '../StyledComponents/img/road.png';
import database from '../StyledComponents/img/database.png';
import sports from '../StyledComponents/img/sports_score.png';
import badge from '../StyledComponents/img/badge.png';
import bar from '../StyledComponents/img/bar_chart_4_bars.png';
import Icon from '../StyledComponents/img/Icon (2).png';
import { DotLoader } from 'react-spinners';
import axios from 'axios';
import Papa from 'papaparse';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

function Tips() {
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddNewListModal, setShowAddNewListModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [expertTips, setExpertTips] = useState([]);
  const [currentTip, setCurrentTip] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const [file, setFile] = useState(null);
  const [tipToDelete, setTipToDelete] = useState(null);
  const [fileName, setFileName] = useState('');
  const [checkedItems, setCheckedItems] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false); // To track the "Select All" checkbox state


  const [formData, setFormData] = useState({
    horseName: '',
    raceNumber: '',
    track: '',
    city: 'Brisbane',
    tipType: 'Free',
    status: 'active',
    created_at: moment().toISOString(),
    currentPrice: '',
    bettingUnit: '',
    analysis: '',
    distance: '',
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };


  const handleSaveAddNewList = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const tipData = {
      ...formData,
      tipDate: moment().format('YYYY-MM-DD HH:mm:ss'),
      created_at: moment().toISOString(),
      status: 'active',
    };

    console.log('Data to be sent to API:', tipData);

    try {
      // Make the POST request
      const response = await axios.post(
        `${process.env.REACT_APP_API_HOSTNAME}/admin/tips/add-tips`,
        tipData
      );

      if (response.status === 200) {
        console.log('API Response:', response.data);
        handleCloseModal(); // Close the modal after successful addition
        window.location.reload();
      } else {
        console.error('Failed to add tip:', response.data);
      }
    } catch (error) {
      console.error('Error posting the data:', error);
    } finally {
      setIsLoading(false); // Reset loading state
    }
  };

  const handleViewClick = (tip) => {
    setCurrentTip(tip); // Set the current tip for viewing
    setShowViewModal(true);
  };



  const handleEditClick = (tip) => {
    setCurrentTip(tip); // Set the current tip for editing
    setShowEditModal(true);
  };

  const handleAddNewListClick = (e) => {
    e.preventDefault();
    setShowAddNewListModal(true);
  };

  const handleExportClick = (e) => {
    e.preventDefault();
    setShowExportModal(true);
  };

  const handleCloseModal = () => {
    setShowViewModal(false);
    setShowDeleteModal(false);
    setShowEditModal(false);
    setShowAddNewListModal(false);
    setShowExportModal(false);
  };




  const [currentPage, setCurrentPage] = useState(1);
  const [totalTipsCount, setTotalTipsCount] = useState(0); // Store total tips count from API
  const tipsPerPage = 8; // Number of tips per page

  const totalPages = Math.ceil(totalTipsCount / tipsPerPage);
  const indexOfLastEntry = currentPage * tipsPerPage;
  const indexOfFirstEntry = indexOfLastEntry - tipsPerPage;
  const currentTips = expertTips.slice(indexOfFirstEntry, indexOfLastEntry);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };



  const hasRun = useRef(false);
  const authCheck = async () => {
    var resp = await verifyauthCheck();
    if (resp != null) {
      if (resp.status === true) {
        navigate(location.pathname, { state: { ...location.state, userData: resp.userData } });
      } else {
        navigate("/");
      }
    }
  };



  const getExpertTips = async () => {
    setIsLoading(true);
    const allTips = [];
    try {
      let totalCount = 0;

      // Fetch data from 5 pages
      for (let page = 1; page <= 5; page++) {
        const resp = await getExpertTipsList({ page: page.toString() }); // API request
        console.log("API Response for page", page, resp); // Log the full API response

        // Collect the tips from each response
        const pageData = _.get(resp, 'data', []);

        // Prepend the new data to the start of the allTips array (newest tips at the top)
        allTips.push(...pageData); // We will append the tips (instead of unshift)

        // Set totalCount based on the first valid response
        if (page === 1 && resp.totalCount) {
          totalCount = resp.totalCount;
        }
      }

      // Update the total tips count (using the first valid page response)
      setTotalTipsCount(totalCount);

      // Sort all the fetched tips by created date or other field if needed
      // If no specific field is available, this step can be skipped
      allTips.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)); // Assuming there's a created_at field

      // Now set the expert tips to state
      setExpertTips(allTips); // Set the fetched expert tips

    } catch (error) {
      console.error("Error fetching expert tips:", error);
    } finally {
      setIsLoading(false);
    }
  };










  const handleSaveChanges = async () => {
    try {
      if (!currentTip.tip_id) {
        console.error('Current Tip ID is missing!');
        return;
      }
      console.log('API URL:', `${process.env.REACT_APP_API_HOSTNAME}/admin/tips/edit-tips/${currentTip.tip_id}`);

      const updatedTipData = {
        horseName: currentTip.horse_name,
        raceNumber: currentTip.race_number,
        track: currentTip.track,
        city: currentTip.city || 'Brisbane',
        tipType: currentTip.tip_type || 'Free',
        status: 'active',
        // here i set moment to set the date Formate
        tipDate:  moment(currentTip.tip_date).format('YYYY-MM-DD') ,
        currentPrice: currentTip.current_price,
        bettingUnit: currentTip.betting_unit,
        analysis: currentTip.analysis,
        distance: currentTip.distance

      };

      console.log('Updating tip with ID:', currentTip.tip_id);

      const response = await axios.put(
        `${process.env.REACT_APP_API_HOSTNAME}/admin/tips/edit-tips/${currentTip.tip_id}`,
        updatedTipData
      );
      console.log("City",updatedTipData.city);

      if (response.status === 200) {
        console.log('Tip updated:', response.data);
        setCurrentTip(response.data);
        handleCloseModal();
        alert('Tip updated successfully!');

        // Refresh the page after successful update
        window.location.reload();
      } else {
        console.error('Failed to update tip:', response.data);
      }
    } catch (error) {
      console.error('Error updating the tip:', error);
    }
  };




  const fileInputRef = useRef(null);

  const handleIconClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // Handle file selection
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
    }
  };

  const handleSaveExport = async () => {
    if (!file) {
      alert("Please select a file to upload.");
      return;
    }

    const validExtensions = ['csv'];
    const fileExtension = file.name.split('.').pop().toLowerCase();

    if (!validExtensions.includes(fileExtension)) {
      alert("Invalid file extension. Please upload a CSV file.");
      return;
    }

    // Parsing the CSV file
    Papa.parse(file, {
      complete: async (result) => {
        if (result.data.length === 0) {
          alert("The file is empty.");
          return;
        }

        const dataToSend = result.data.map(row => ({
          horse_name: row.horse_name,
          race_number: row.race_number,
          track: row.track,
          city: row.city,
          tip_type: row.tip_type,
          status: row.status,
          tip_date: row.tip_date,
          current_price: row.current_price,
          betting_unit: row.betting_unit,
          analysis: row.analysis,
          distance: row.distance

        }));

        const formData = new FormData();
        formData.append("file", file);

        try {
          const response = await axios.post(`${process.env.REACT_APP_API_HOSTNAME}/admin/tips/import-tips`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });

          if (response.status === 200) {
            console.log('File uploaded successfully:', response.data);
            setShowExportModal(false);
            window.location.reload();
          } else {
            console.error('Failed to upload file', response.data);
            alert('Failed to upload file. Please try again.');
          }
        } catch (error) {
          console.error('Error uploading file:', error);
          if (error.response) {
            alert(`Server error: ${error.response.status}`);
          } else if (error.request) {
            alert('No response from server. Please check your internet connection or try again later.');
          } else {
            alert('An error occurred while uploading the file.');
          }
        }
      },
      error: (error) => {
        console.error('Error parsing CSV:', error);
        alert('There was an error parsing the CSV file. Please try again.');
      }
    });
  };



  const handleDeleteClick = (tip) => {
    setTipToDelete(tip);
    setShowDeleteModal(true);
  };

  const handleDelete = async () => {
    if (!tipToDelete) return;

    try {
      const response = await axios.delete(`${process.env.REACT_APP_API_HOSTNAME}/admin/tips/delete-tips/${tipToDelete.tip_id}`);

      if (response.status === 200) {
        console.log('Tip deleted:', response.data);

        await getExpertTips();

        setShowDeleteModal(false);
        alert('Tip delete successfully!');
        window.location.reload();
      } else {
        console.error('Failed to delete tip:', response.data);
      }
    } catch (error) {
      console.error('Error deleting the tip:', error);
      alert('Failed to delete the tip. Please try again.');
    }
  };




  useEffect(() => {
    if (!hasRun.current) {
      hasRun.current = true;
      authCheck();
      getExpertTips();
    }
  }, [currentPage]);





  console.log('Total Tips Count:', totalTipsCount);
  console.log('Current Page:', currentPage);
  console.log('Index of First Entry:', indexOfFirstEntry);
  console.log('Index of Last Entry:', indexOfLastEntry);
  console.log('Current Tips:', currentTips);





  const handleSelectAllChange = (e) => {
    const checked = e.target.checked;
    setSelectAllChecked(checked); // Update the "Select All" state

    if (checked) {
      // Select all items (set all tip_ids to checkedItems)
      const allTipIds = expertTips.map((tip) => tip.tip_id); // Get all tip IDs
      setCheckedItems(allTipIds); // Update checkedItems with all tip IDs
    } else {
      // Deselect all items
      setCheckedItems([]); // Clear checkedItems
    }
  };

  // Handle individual checkbox change
  const handleCheckboxChange = (e, tipId) => {
    const checked = e.target.checked; // Get the checked state of the checkbox
    let updatedCheckedItems;

    if (checked) {
      // Add the selected tipId to checkedItems if it's checked
      updatedCheckedItems = [...checkedItems, tipId];
    } else {
      // Remove the unchecked tipId from checkedItems
      updatedCheckedItems = checkedItems.filter((id) => id !== tipId);
    }

    setCheckedItems(updatedCheckedItems); // Update checkedItems with the new list
  };

  // Update the Select All checkbox state when individual checkboxes change
  useEffect(() => {
    // If the number of checked items matches the total number of tips, check Select All
    if (checkedItems.length === expertTips.length) {
      setSelectAllChecked(true); // All tips are selected, check Select All
    } else {
      setSelectAllChecked(false); // Not all tips are selected, uncheck Select All
    }
  }, [checkedItems, expertTips.length]);



  
  const handleDeleteSelected = async () => {
    if (checkedItems.length === 0) {
      alert("Please select at least one tip to delete.");
      return;
    }

    console.log("Selected tips to delete:", checkedItems);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_HOSTNAME}/admin/tips/delete-all-tips`, {
        ids: checkedItems
      });

      if (response.status === 200) {
        console.log('Selected tips deleted:', response.data);
        setCheckedItems([]);
        alert('Selected tips deleted successfully!');
      } else {
        console.error('Failed to delete selected tips:', response.data);
        alert('Failed to delete selected tips. Please try again.');
      }
    } catch (error) {
      console.error('Error deleting selected tips:', error);
      alert('Failed to delete selected tips. Please try again.');
    }
  };




  return (
    <div className="right" style={{ overflow: "hidden" }}>
      <div className="title">
        <h2>Manage Tips</h2>
      </div>
      <div >
        {isLoading ? (
          <div className="loading-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', marginLeft: '450px', marginTop: '90px' }}>
            <DotLoader color="#F7812A" size={60} />
          </div>
        ) : (
          <div className="table">
            <div className="button-group" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div className="export-button-container">

                <a className="export-button1" style={{ cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    style={{
                      borderColor: 'orange',
                      outline: 'none',
                      cursor: 'pointer',
                      width: '17px',
                      height: '17px'
                    }}
                    checked={selectAllChecked}
                    onChange={handleSelectAllChange}
                  />
                  Select All
                </a>
              </div>
              <div className="add-new-list-container">
                <a style={{ cursor: 'pointer' }} className="add-new-list-button" onClick={handleAddNewListClick}>+ Add New Tips</a>
              </div>
              <div className="export-button-container">
                <a style={{ cursor: 'pointer' }} className="export-button" onClick={handleExportClick}>
                  <FontAwesomeIcon icon={faDownload} />
                  Tips Import
                </a>
              </div>
              <div className="export-btn-container" style={{ marginLeft: 'auto', marginRight: '10px', cursor: 'pointer' }}>
                <a style={{ cursor: 'pointer' }} className="export-btn" onClick={handleDeleteSelected}>
                  Delete  Tips
                </a>
              </div>
            </div>

            {/* Show loading spinner when data is being fetched */}

            <table>
              <tr>
                <th>Date</th>
                <th>Race Number</th>
                <th>Track</th>
                <th>Horse name</th>
                <th>City</th>
                <th>Tips</th>
              </tr>

              {/* Render Tips */}
              {currentTips.map((tip, index) => (
                <tr key={index}>

                  <td style={{ display: 'flex', alignItems: 'center', position: 'relative', marginTop: '10px' }}>
                    <input
                      type="checkbox"
                      style={{
                        borderColor: 'orange',
                        outline: 'none',
                        cursor: 'pointer',
                        width: '17px',
                        height: '17px'
                      }}
                      checked={checkedItems.includes(tip.tip_id)}
                      onChange={(e) => handleCheckboxChange(e, tip.tip_id)}
                    />
                    <span style={{ marginLeft: '10px' }} >
                      {moment(tip.created_at).format("D MMMM YYYY")}
                    </span>


                  </td>


                  <td>{tip.race_number}</td>
                  <td>{tip.track}</td>
                  <td>{tip.horse_name}</td>
                  <td>
                    <a href="" style={{ display: 'inline-block', padding: '15px 30px', backgroundColor: '#F7812A', color: 'white', textDecoration: 'none', borderRadius: '30px', fontSize: '14px' }}>
                      {tip.city}
                    </a>
                  </td>
                  <td>
                    {tip.tip_type}
                    <a style={{ cursor: 'pointer' }} onClick={() => handleViewClick(tip)}>
                      <FontAwesomeIcon icon={faEye} style={{ color: 'grey', marginLeft: 20 }} />
                    </a>
                    <a style={{ cursor: 'pointer' }} onClick={() => handleDeleteClick(tip)}>
                      <FontAwesomeIcon icon={faTrash} style={{ color: 'red', marginLeft: 20 }} />
                    </a>
                    <a style={{ cursor: 'pointer' }} onClick={() => handleEditClick(tip)}>
                      <FontAwesomeIcon icon={faPenToSquare} style={{ color: 'grey', marginLeft: 20 }} />
                    </a>
                  </td>
                </tr>
              ))}
            </table>
            <hr className="horizontal-line" />
            <div className="pagination">
              <span>
                Showing {Math.min(indexOfLastEntry, totalTipsCount)} of {totalTipsCount} entries
              </span>

              <div className="pagination-buttons">
                {/* Render page numbers dynamically */}
                {[...Array(totalPages)].map((_, index) => (
                  <button
                    key={index}
                    onClick={() => handlePageChange(index + 1)}
                    className={currentPage === index + 1 ? 'active' : ''}
                  >
                    {index + 1}
                  </button>
                ))}

                {/* Next button */}
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>
            </div>

            {isLoading && <p>Loading...</p>} {/* Display loading indicator */}






          </div>
        )}
        {/* Modal for Viewing Details */}
        {showViewModal && currentTip && (
          <div className="modal-overlay" onClick={handleCloseModal}>

            <div class="tipdetail-main">
              <div className="edit-form tip-edit">
                <div className="form" >
                  <form action="">
                    <div className="heading">
                      <h2>{currentTip.track}</h2>
                      <a href="">  <FontAwesomeIcon icon={faLocationDot} />  {currentTip.city}</a>
                    </div>

                    <div className="icon-top">
                      <div className="icon">
                        <img src={road} alt="" />
                        <h4>{currentTip.distance }</h4>
                      </div>
                      <div className="icon">
                        <img src={database} alt="" />
                        <h4>{currentTip.betting_unit} u</h4>
                      </div>
                      <div className="icon">
                        <img src={sports} alt="" />
                        <h4>Race {currentTip.race_number}</h4>
                      </div>
                    </div>
                    <div className="icon-bottom">
                      <div className="icon">
                        <img src={badge} alt="" />
                        <h4>{currentTip.horse_name}</h4>
                      </div>
                      <div className="icon">
                        <img src={Icon} alt="" />
                        <h4>${currentTip.current_price}</h4>
                      </div>
                    </div>

                    <div className="description">
                      <div className="icon">
                        <img src={bar} alt="" />
                        <h4>Analysis</h4>
                      </div>
                      <p>{currentTip.analysis}</p>
                    </div>


                  </form>
                </div>
              </div>
            </div>
          </div>

        )}

        {showDeleteModal && (
          <div className="modal-overlay">
            <div className="edit-form change-sub">
              <div className="form">
                <form action="">
                  <h2>Delete</h2>
                  <p>Are you sure you want to Delete?</p>

                  <div className="theme-btn log-out">
                    <div className="btn">
                      <a style={{ cursor: 'pointer' }} onClick={handleDelete}>Delete</a>
                    </div>

                    <div className="btn btn2">
                      <button
                        onClick={handleCloseModal}
                        style={{
                          color: 'black',
                          fontSize: '16px',
                          cursor: 'pointer',
                          border: 'none',
                          background: 'none',
                          textDecoration: 'none',
                        }}
                      >
                        Cancel
                      </button>


                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

        )}

        {/* Modal for Editing */}
        {showEditModal && currentTip && (
          <div className="modal-overlay">
            <div className="edit-form">
              <div className="form">
                <form action="">
                  <h2>Edit Details</h2>
                  <div className="form-feild">
                    <div className="form-group fullname">
                      <label htmlFor="track">Track</label>
                      <input
                        type="text"
                        id="track"
                        value={currentTip.track || ''}
                        onChange={(e) => setCurrentTip({ ...currentTip, track: e.target.value })}
                      />
                    </div>
                    <div className="form-group fullname">
                      <label htmlFor="currentPrice">Current price</label>
                      <input
                        type="text"
                        id="currentPrice"
                        value={currentTip.current_price || ''}
                        onChange={(e) => setCurrentTip({ ...currentTip, current_price: e.target.value })}
                      />
                      <i className="">AUD</i>
                    </div>
                  </div>

                  <div className="form-feild">
                    <div className="form-group fullname">
                      <label htmlFor="tipType">Tip Type</label>
                      <div className="input-with-icon">
                        <select
                          id="tipType"
                          value={currentTip.tip_type || ''}
                          onChange={(e) => setCurrentTip({ ...currentTip, tip_type: e.target.value })}
                        >
                          {/* First option - show the opposite value of current tip_type */}
                          <option value={currentTip.tip_type === 'paid' ? 'free' : 'paid'}>
                            {currentTip.tip_type === 'paid' ? 'Free' : 'Paid'}
                          </option>

                          {/* Second option - show the current value */}
                          <option value={currentTip.tip_type || ''}>
                            {currentTip.tip_type === 'paid' ? 'Paid' : 'Free'}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div className="form-group fullname">
                      <label htmlFor="city">City</label>
                      <div className="input-with-icon">
                        <select
                          value={currentTip.city || ''}
                          onChange={(e) => setCurrentTip({ ...currentTip, city: e.target.value })}
                        >
                          {/* Conditionally render options based on the tip_type */}
                          {currentTip.tip_type === 'paid' ? (
                            <>
                              <option value="Melbourne">Melbourne</option>
                              <option value="Brisbane">Brisbane</option>
                              <option value="Sydney">Sydney</option>
                              <option value="Best Bet">Best Bet</option> //here vijay replace Best Bets to Best Bet
                            </>
                          ) : (
                            <>
                              <option value="Melbourne">Melbourne</option>
                              <option value="Brisbane">Brisbane</option>
                              <option value="Sydney">Sydney</option>
                            </>
                          )}
                        </select>
                      </div>
                    </div>
                  </div>


                  <div className="form-feild">
                    <div className="form-group fullname">
                      <label htmlFor="raceNumber">Race Number</label>
                      <input
                        type="text"
                        id="raceNumber"
                        value={currentTip.race_number || ''}
                        onChange={(e) => setCurrentTip({ ...currentTip, race_number: e.target.value })}
                      />
                    </div>
                    <div className="form-group fullname">
                      <label htmlFor="bettingUnit">Recommended betting unit</label>
                      <input
                        type="text"
                        id="bettingUnit"
                        value={currentTip.betting_unit || ''}
                        onChange={(e) => setCurrentTip({ ...currentTip, betting_unit: e.target.value })}
                      />
                    </div>
                  </div>
                  <div className="form-feild">
                    <div className="form-group fullname">
                      <label htmlFor="horseName">Horse name</label>
                      <input
                        type="text"
                        id="horseName"
                        value={currentTip.horse_name || ''}
                        onChange={(e) => setCurrentTip({ ...currentTip, horse_name: e.target.value })}
                      />
                    </div>
                    <div className="form-group fullname">
                      <label htmlFor="Distance">Distance </label>
                      <input
                        type="text"
                        id="Distance"
                        value={currentTip.distance || ''}
                        onChange={(e) => setCurrentTip({ ...currentTip, distance: e.target.value })}
                      />
                    </div>
                  </div>


                  <div className="form-group fullname">
                    <label htmlFor="analysis">Analysis</label>
                    <textarea
                      id="analysis"
                      value={currentTip.analysis || ''}
                      onChange={(e) => setCurrentTip({ ...currentTip, analysis: e.target.value })}
                    />
                  </div>

                  <div className="theme-btn">
                    <div className="btn">
                      <a style={{ cursor: 'pointer' }} onClick={handleSaveChanges}>Done</a>
                    </div>

                    <div className="btn btn2">
                      <a style={{ cursor: 'pointer' }} onClick={handleCloseModal}>Cancel</a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* Modal for Adding New Tip */}
      {showAddNewListModal && (
        <div className="modal-overlay">
          <div className="edit-form">
            <form onSubmit={handleSaveAddNewList}>
              <h2>Add new tip</h2>

              <div className="form-feild">
                <div className="form-group fullname">
                  <label htmlFor="horseName">Horse Name</label>
                  <input
                    type="text"
                    id="horseName" // Match the formData key name
                    value={formData.horseName}
                    onChange={handleInputChange}
                    placeholder="Enter Horse name"
                  />
                </div>
                <div className="form-group fullname">
                  <label htmlFor="currentPrice">Current Price</label>
                  <input
                    type="text"
                    id="currentPrice" // Match the formData key name
                    value={formData.currentPrice}
                    onChange={handleInputChange}
                    placeholder="$ Enter Amount"
                  />
                  <i>AUD</i>
                </div>
              </div>

              <div className="form-feild">
                <div className="form-group fullname">
                  <label htmlFor="tipType">Tip Type</label>
                  <select
                    id="tipType"
                    value={formData.tipType}
                    onChange={handleInputChange}
                  >
                    <option value="Free">Free</option>
                    <option value="Paid">Paid</option>
                  </select>
                </div>

                <div className="form-group fullname">
                  <label htmlFor="city">City</label>
                  <select
                    id="city"
                    value={formData.city}
                    onChange={handleInputChange}
                  >
                    {formData.tipType === 'Free' ? (
                      <>
                        <option value="Brisbane">Brisbane</option>
                        <option value="Sydney">Sydney</option>
                        <option value="Melbourne">Melbourne</option>
                      </>
                    ) : (
                      <>
                        <option value="Brisbane">Brisbane</option>
                        <option value="Sydney">Sydney</option>
                        <option value="Melbourne">Melbourne</option>
                        {/* I'll replace the "All (Best Bet)" option with a new one */}
                        <option value="Best Bet">Best Bet</option>
                      </>
                    )}
                  </select>
                </div>
              </div>

              <div className="form-feild">
                <div className="form-group fullname">
                  <label htmlFor="raceNumber">Race Number</label>
                  <input
                    type="text"
                    id="raceNumber" // Match the formData key name
                    value={formData.raceNumber}
                    onChange={handleInputChange}
                    placeholder="Enter Race Number"
                  />
                </div>
                <div className="form-group fullname">
                  <label htmlFor="bettingUnit">Betting Unit</label>
                  <input
                    type="text"
                    id="bettingUnit" // Match the formData key name
                    value={formData.bettingUnit}
                    onChange={handleInputChange}
                    placeholder="Enter Betting Unit"
                  />
                </div>
              </div>
              <div className="form-feild">
                <div className="form-group fullname">
                  <label htmlFor="track">Track</label>
                  <input
                    type="text"
                    id="track" // Match the formData key name
                    value={formData.track}
                    onChange={handleInputChange}
                    placeholder="Enter Track"
                  />
                </div>
                <div className="form-group fullname">
                  <label htmlFor="track">Distance</label>
                  <input
                    type="text"
                    id="distance" // Match the formData key name
                    value={formData.distance}
                    onChange={handleInputChange}
                    placeholder="Enter Distance"
                  />
                </div>
              </div>


              <div className="form-group fullname">
                <label htmlFor="analysis">Analysis</label>
                <textarea
                  id="analysis" // Match the formData key name
                  value={formData.analysis}
                  onChange={handleInputChange}
                  placeholder="Write here..."
                />
              </div>

              <div className="theme-btn" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div className="btn">
                  <button type="submit" style={{
                    backgroundColor: '#F7812A',
                    color: 'white',
                    width: '160px',
                    height: '60px',
                    borderRadius: '50px',
                    border: 'none',  // Remove the button border
                    fontSize: '19px',
                    // fontWeight:'bold'
                  }}>Create</button>
                </div>

                <div className="btn btn2">
                  <a style={{ cursor: 'pointer' }} onClick={handleCloseModal}>Cancel</a>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
      {
        showExportModal && (
          <div className="modal-overlay">
            <div className="edit-form import-tip" >
              <div className="form">
                <form action="">
                  <h2>Import Tips</h2>

                  <div className="form-group fullname" >
                    <input
                      className="file-input"
                      type="file"
                      name="file"
                      ref={fileInputRef} // Reference to the file input
                      hidden
                      onChange={handleFileChange}
                    />
                    <FontAwesomeIcon
                      icon={faCloudUploadAlt} // Use the FontAwesomeIcon component
                      size="2x"
                      onClick={handleIconClick} // Adjust icon size as needed
                      style={{ marginBottom: '-80px' }}
                    />
                    <p style={{ marginBottom: '10px' }}>
                      {fileName ? `Selected File: ${fileName}` : 'Browse File to Upload'}
                    </p>
                  </div>

                  <div className="theme-btn">
                    <div className="btn">
                      <a style={{ cursor: 'pointer' }} onClick={handleSaveExport}>Upload</a>
                    </div>

                    <div className="btn btn2">
                      <a style={{ cursor: 'pointer' }} onClick={handleCloseModal}>Cancel</a>
                    </div>
                  </div>

                </form>
              </div>
            </div>
          </div>
        )
      }
    </div >
  );
}

export default Tips;
